let model = {};

model.dataForm = {
  "loai_hinh_uu_dai": undefined, // optional, enum(giam_gia_tien, giam_gia_phan_tram) - Loại hình ưu đãi
  "gia_tri_uu_dai": undefined, // optional, min: 0 - Giá trị ưu đãi
  "huong_dan_vien": // optional - Các thông tin cho hướng dẫn viên
  {
    "uu_dai": // optional - Thông tin ưu đãi
    {
      "loai_hinh_uu_dai": undefined, // optional, enum(giam_gia_tien, giam_gia_phan_tram) - Loại hình ưu đãi
      "gia_tri_uu_dai": undefined, // optional, min: 0 - Giá trị ưu đãi
    }
  }
};

export default model;
